var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0.111328C11.2555 0.111328 0.111084 11.2558 0.111084 25.0002C0.111084 38.7447 11.2555 49.8891 25 49.8891C38.7444 49.8891 49.8889 38.7447 49.8889 25.0002C49.8889 11.2558 38.7444 0.111328 25 0.111328ZM35.75 16.8724L24.05 33.0947C23.8864 33.3229 23.6709 33.5089 23.4211 33.6372C23.1714 33.7655 22.8946 33.8324 22.6139 33.8324C22.3331 33.8324 22.0564 33.7655 21.8066 33.6372C21.5569 33.5089 21.3413 33.3229 21.1778 33.0947L14.25 23.4947C14.0389 23.2002 14.25 22.7891 14.6111 22.7891H17.2166C17.7833 22.7891 18.3222 23.0613 18.6555 23.528L22.6111 29.0169L31.3444 16.9058C31.6778 16.4447 32.2111 16.1669 32.7833 16.1669H35.3889C35.75 16.1669 35.9611 16.578 35.75 16.8724Z",
    fill: "#45BB66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.4a984c70652017e72e55106b54f53bff.svg";
export { ForwardRef as ReactComponent };